import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { AccountContent, HeroBanner } from "~/components/sections";
import { Header, Footer } from "~/components/blocks";

import { Grid } from "@material-ui/core";
import { Breadcrumb } from "~/components/elements";
import { Creators as AccountActions } from "~/store/modules/account/actions";
import { Creators as AuthActions } from "~/store/modules/authentication/actions";

import { Helmet } from "react-helmet";
import { scrollTo } from "~/utils/tools";
import { useHistory, useLocation } from "react-router-dom";
import {redirectSignUpFlow} from "~/pages/helper";
import promoIsActive from "~/utils/promoIsActive";

export default function MyAccount() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const personalData = useSelector((state) => state.account.details.dadosPessoais);
  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },
    {
      text: "Minha conta",
      link: "/minha-conta",
    },
  ];

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  useEffect(() => {
    scrollTo(700);
    dispatch(AuthActions.setValidateAuth());
    dispatch(AccountActions.getUserDetails());
  }, [dispatch]);

  useEffect(() => {
    scrollTo(700);

    if (promoIsActive()) {
      redirectSignUpFlow(personalData?.DocumentoCrip, personalData?.Filhos, personalData?.Instagram, history, location, personalData?.cupons)
    }
  }, [dispatch, url, origin, history, location, personalData]);

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Minha conta</title>
      </Helmet>
      <Header />
      <HeroBanner />
      <motion.div
      style={{backgroundColor: "#F5F5F5"}}
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <Breadcrumb navBreadcrumb={navBreadcrumb} />

        <Grid container justifyContent="space-between">
          <AccountContent />
        </Grid>
      </motion.div>
      <Footer />
    </>
  );
}
